import { createAction } from 'redux-actions'
import {
  ADD_DEPARTMENT,
  ADD_DEPARTMENT_FAILED,
  ADD_DEPARTMENT_SUCCEEDED,
  CLEAR_CREATED_DEPARTMENT,
  DELETE_DEPARTMENT,
  DELETE_DEPARTMENT_FAILED,
  DELETE_DEPARTMENT_SUCCEEDED,
  GET_DEPARTMENTS,
  GET_DEPARTMENTS_FAILED,
  GET_DEPARTMENTS_SUCCEEDED,
} from 'Redux/Types/DepartmentTypes'

export const deleteDepartment = createAction(DELETE_DEPARTMENT)
export const deleteDepartmentFailed = createAction(DELETE_DEPARTMENT_FAILED)
export const deleteDepartmentSucceeded = createAction(DELETE_DEPARTMENT_SUCCEEDED)

export const getDepartments = createAction(GET_DEPARTMENTS)
export const getDepartmentsFailed = createAction(GET_DEPARTMENTS_FAILED)
export const getDepartmentsSucceeded = createAction(GET_DEPARTMENTS_SUCCEEDED)

export const addDepartment = createAction(ADD_DEPARTMENT)
export const addDepartmentFailed = createAction(ADD_DEPARTMENT_FAILED)
export const addDepartmentSucceeded = createAction(ADD_DEPARTMENT_SUCCEEDED)
export const clearCreatedDepartment = createAction(CLEAR_CREATED_DEPARTMENT)
